export class UpdateStepEntrepriseOrder {

	id!: number;
	idEntrepriseEu: number | null = null;
	idResponsableEu: number | null = null;
	raisonSocialeEu!: string;
	adresseEntrepriseEu!: string;
	nomPrenomResponsableEu!: string;
	emailResponsableEu!: string;
	fonctionResponsableEu!: string;
	indicatifResponsableEu: string | null = null;;
	phoneResponsableEu!: string;
	numeroAstreintesEu!: string[];
	euEmailHasChanged!: boolean;
	euPhoneHasChanged!: boolean;
	euHasSigned!: boolean;
	
	idEntrepriseEe: number | null = null;
	idResponsableEe: number | null = null;
	raisonSocialeEe!: string;
	adresseEntrepriseEe!: string;
	nomPrenomResponsableEe!: string;
	emailResponsableEe!: string;
	fonctionResponsableEe!: string;
	indicatifResponsableEe: string | null = null;;
	phoneResponsableEe!: string;
	eeEmailHasChanged!: boolean;
	eePhoneHasChanged!: boolean;
	eeHasSigned!: boolean;
}
